// extracted by mini-css-extract-plugin
module.exports = {"root":"ActivitySigningMore_root__l6FV0","disableInset":"ActivitySigningMore_disableInset__3PZyS"};